import cx from 'classnames';
import React, { ButtonHTMLAttributes, forwardRef } from 'react';

import styles from './temp_style/button.module.scss';

export interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'ghost'
    | 'destructive'
    | 'outline'
    | 'link'
    | 'without-border'
    | 'gray'
    | 'auth-button'
    | 'red'
    | 'secondary-red';
  size?: 'm' | 'l';
  buttonType?: 'default' | 'icon';
  width?: 'default' | 'fit-content';
}

export const Button = forwardRef<HTMLButtonElement, IButton>(
  (
    {
      children,
      variant = 'primary',
      size = 'm',
      buttonType = 'default',
      width = 'default',
      className,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={cx(
          styles.button,
          styles[`button--${variant}`],
          styles[`button-size--${size}`],
          styles[`button-type--${buttonType}`],
          styles[`button-width--${width}`],
          className,
          props.disabled && styles.disabled
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';
